// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_FUNDRAISING, REPORT_CONFIG_NAME_PROSPECTS } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the Fundraising (prospects) table column layout (from global configs). */
export function useFundraisingReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(
        reportingConfigs,
        menuItems,
        MENU_ITEM_KEY_FUNDRAISING,
        REPORT_CONFIG_NAME_PROSPECTS
      ),
    [menuItems, reportingConfigs]
  )
}
